/** @format */

export const WarningSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.00033 3.99331L13.0203 12.6666H2.98033L8.00033 3.99331ZM8.00033 1.33331L0.666992 14H15.3337L8.00033 1.33331ZM8.66699 10.6666H7.33366V12H8.66699V10.6666ZM8.66699 6.66665H7.33366V9.33331H8.66699V6.66665Z"
                fill={color}
            />
        </svg>
    );
};
